import { render, staticRenderFns } from "./HolidayDetails.vue?vue&type=template&id=5bdf17b8&scoped=true&"
import script from "./HolidayDetails.vue?vue&type=script&lang=js&"
export * from "./HolidayDetails.vue?vue&type=script&lang=js&"
import style0 from "./HolidayDetails.vue?vue&type=style&index=0&id=5bdf17b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf17b8",
  null
  
)

export default component.exports